export default __webpack_public_path__ + "static/media/video.65861429.mp4";